import React, { FunctionComponent, useCallback, useState } from 'react'
import styles from './LoginPage.module.sass'
import { useDispatch } from 'react-redux'
import { Dispatch } from 'redux'
import { RootActions } from '../../../../redux/root'
import { userActions } from '../../../../redux/global/user/user-actions'
import Field from '../../../controls/Field/Field'
import { Intent } from '../../../controls/Intent'
import Button, { ButtonStyle, Size } from '../../../controls/Button/Button'
import EyeIcon from 'files/eye.svg'
import EyeOffIcon from 'files/eye-off.svg'
import HeaderLogo from '../../../navigation/Header/HeaderLogo/HeaderLogo'

const LoginPage: FunctionComponent = () => {
    const [showPass, setShowPass] = useState(false)
    const [login, setLogin] = useState('')
    const [password, setPassword] = useState('')

    const dispatch = useDispatch<Dispatch<RootActions>>()
    const loginRequest = useCallback(() =>
        dispatch(userActions.login.request({ login, password })),
        [dispatch, login, password]
    )

    return <div className={styles.page}>
        <div className={styles.card}>
            <span className={styles.logo_wrapper}>
                <HeaderLogo/>
            </span>
            <Field
                autoFocus
                intent={Intent.DARK}
                className={styles.field}
                value={login}
                placeholder={'Email'}
                onChange={setLogin}
                onEnter={loginRequest}
            />
            <Field
                intent={Intent.DARK}
                className={styles.field}
                value={password}
                placeholder={'Пароль'}
                onChange={setPassword}
                type={showPass ? 'text' : 'password'}
                onEnter={loginRequest}
                rightItem={<Button
                    // todo решить с исключением
                    // intent={Intent.DARK}
                    onClick={() => setShowPass(!showPass)}
                >
                    {
                        showPass? <EyeIcon/>: <EyeOffIcon/>
                    }
                </Button>}
            />
            <Button
                className={styles.button}
                buttonStyle={ButtonStyle.BORDERED}
                justify={'center'}
                // todo решить с исключением
                // intent={Intent.DARK}
                size={Size.HUGE}
                onClick={loginRequest}
            >
                Войти
            </Button>
        </div>
        <div className={styles.copyright}>© 2019 «TTG solutions»</div>
    </div>
}

export default LoginPage
